import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BusinessPartnerProviderConfig } from '../../../model/provider';

@Component({
  selector: 'app-delete-provider-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './delete-provider-dialog.html',
  styleUrl: './delete-provider-dialog.css'
})
export class DeleteProviderDialog {
  @Input() provider: BusinessPartnerProviderConfig | null = null;
  @Input() submitting: boolean = false;
  @Output() closed = new EventEmitter<void>();
  @Output() confirmDelete = new EventEmitter<void>();

  protected onCancel(): void {
    this.closed.emit();
  }

  protected onConfirm(): void {
    this.confirmDelete.emit();
  }
}
